import { render } from "./IconoMapa.vue?vue&type=template&id=f05e5c48&scoped=true"
import script from "./IconoMapa.vue?vue&type=script&lang=js"
export * from "./IconoMapa.vue?vue&type=script&lang=js"

import "./IconoMapa.vue?vue&type=style&index=0&id=f05e5c48&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend_ahdeco/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05e5c48"]])

export default __exports__